import api, { adminApiPrefix } from './Api';

import { PaginatedResponse } from '../interfaces/PaginatedResponse';

import {
  BoynerOrderFilter,
  boynerOrderFilterToQueryParams,
} from '../interfaces/Boyner/BoynerOrderFilter';
import {
  BoynerOrder,
  boynerOrderFromResponse,
} from '../interfaces/Boyner/BoynerOrder';

const boynerAdminApiPrefix = `${adminApiPrefix}/boyner`;

export const getBoynerOrders = async (
  filter: BoynerOrderFilter,
): Promise<PaginatedResponse<BoynerOrder>> => {
  const response = await api.get(`${boynerAdminApiPrefix}/orders`, {
    params: boynerOrderFilterToQueryParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map((order: any) =>
      boynerOrderFromResponse(order),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const checkBoynerStatus = async (): Promise<void> =>
  api.get(`${boynerAdminApiPrefix}/status`);
